<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title @click="setInit">
        {{ $t('shopSetting') }}
      </v-toolbar-title>
      <v-spacer />
    </v-app-bar>
    <v-card-text class="text--primary">
      <v-row
        v-if="synce"
        class="fill-height"
        align-content="center"
        justify="center"
      >
        <v-col
          class="text-center"
          cols="12"
        >
          {{ $t('gettingPosts') }}
        </v-col>
        <v-col cols="6">
          <v-progress-linear
            color="deep-purple accent-4"
            indeterminate
            rounded
            height="6"
          />
        </v-col>
      </v-row>
      <v-row v-if="!synce">
        <v-col
          class=" px-2"
          cols="12"
          md="4"
        >
          <autocomplete
            v-model="entrepot"
            title="entrepot"
            type="entrepot"
            :value="entrepot"
          />
        </v-col>
        <v-col
          class=" px-2"
          cols="12"
          md="4"
        >
          <money
            v-model="shippingPrice"
            :label="$t('shippingPrice')"
            :dense="true"
            :outlined="true"
            :solo="false"
            :clearable="true"
            value-when-is-empty=""
            :options="options"
            class="mb-3 dense"
          />
        </v-col>
        <v-col
          cols="12"
          class="my-0 px-1 py-0"
          style="height: auto !important;"
        >
          <tiptap-vuetify
            v-model="rules"
            :extensions="extensions"
            :toolbar-attributes="{ color: '#ababab', dark: true }"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions
      v-if="!synce"
      class="pt-0"
    >
      <v-row class="ma-0">
        <v-col
          cols="6"
          class="px-1"
        >
          <v-btn
            color="primary"
            class="mr-0"
            @click="update"
          >
            {{ $t('submit') }}
          </v-btn>
        </v-col>
        <v-col
          cols="6"
          class="px-2"
        />
      </v-row>
    </v-card-actions>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;top: 20px"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import General from '../../../../Mixins/general'
  import autocomplete from '../../components/general/patial/autocomplete'
  import {
    TiptapVuetify,
    Heading,
    Bold,
    Italic,
    Strike,
    Underline,
    Code,
    Paragraph,
    BulletList,
    OrderedList,
    ListItem,
    Link,
    Blockquote,
    HardBreak,
    HorizontalRule,
    History,
    Image,
    Table,
    TableCell,
    TableHeader,
    TableRow,
  } from 'tiptap-vuetify'
  export default {
    name: 'ShopInitialize',
    components: {
      TiptapVuetify,
      autocomplete,
    },
    mixins: [General],
    props: ['input', 'refId'],
    data: () => ({
      id: null,
      extensions: [
        History,
        Table,
        TableCell,
        TableHeader,
        TableRow,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem, // if you need to use a list (BulletList, OrderedList)
        BulletList,
        OrderedList,
        Image,
        [
          Heading,
          {
            // Options that fall into the tiptap's extension
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak, // line break on Shift + Ctrl + Enter
      ],
      entrepot: null,
      rules: null,
      synce: true,
      loading: false,
      shippingPrice: null,
    }),
    computed: {
    },
    watch: {
    },
    activated () {
    },
    beforeMount () {
    },
    mounted () {
      this.setInit()
    },
    methods: {
      setInit () {
        var app = this
        app.loading = true
        app.synce = true
        app.$axios.get(this.$endpoint + 'shopManagement', {
          params: {
            setInit: 'active',
          },
        })
          .then(res => {
            res = res.data
            app.entrepot = res.shop.entrepot
            app.shippingPrice = res.shop.shipping_price
            app.rules = res.shop.rules
            app.id = res.shop.id
            if (res.postAddedCount > 0) {
              app.snakbarText = res.postAddedCount + ' ' + app.$t('postAdded')
              app.snakbarColor = 'blue'
              app.snakbar = true
            }
            app.synce = false
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      update () {
        var app = this
        app.loading = true
        app.$axios.put(this.$endpoint + 'shopManagement/' + this.id, this.$data)
          .then(res => {
            res = res.data
            app.snakbarText = app.$t('registered')
            app.snakbarColor = 'green'
            app.snakbar = true
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.loading = false
          })
      },
    },
  }
</script>

<style scoped>

</style>
